export const SET_TARGET_TYPE = "targetType/SET_TARGET_TYPE";

export const saveTargetType = (targetType: string) => {
  return {
    type: SET_TARGET_TYPE,
    payload: { targetType },
  };
};
